import { testimonials } from '@/mocks/articles';

export default function Reputation() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-label font-semibold text-primary-600 bg-primary-50 rounded-full">
            读者口碑
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            百万吃瓜群众的选择
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自真实读者的评价，是我们前进的最大动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-100 rounded-lg border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className={`text-sm ${i < Math.floor(t.rating) ? 'ri-star-fill text-amber-400' : i < t.rating ? 'ri-star-half-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}></i>
                  </span>
                ))}
                <span className="text-xs text-foreground-400 ml-1 font-label">{t.rating}</span>
              </div>

              <blockquote className="text-sm text-foreground-600 leading-relaxed mb-4">
                "{t.comment}"
              </blockquote>

              <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-label font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.date}</p>
                </div>
              </div>
            </div>
          ))}

          {/* Extra testimonial card */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 p-5 md:p-6">
            <div className="flex items-center gap-1 mb-3">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="w-4 h-4 flex items-center justify-center">
                  <i className="text-sm ri-star-fill text-amber-400"></i>
                </span>
              ))}
              <span className="text-xs text-foreground-400 ml-1 font-label">5.0</span>
            </div>
            <blockquote className="text-sm text-foreground-600 leading-relaxed mb-4">
              "莫里秀栏目真的是业界良心，每篇调查报道都让人看得过瘾。更重要的是能感觉到编辑团队是真的用心在做内容，不是那种随便抄抄就发出来的垃圾号。"
            </blockquote>
            <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
              <div className="w-10 h-10 rounded-full flex items-center justify-center bg-accent-100 flex-shrink-0">
                <i className="ri-user-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <p className="text-sm font-label font-semibold text-foreground-900">吃瓜达人老李</p>
                <p className="text-xs text-foreground-400">2026-06-20</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}